import cn from './city_name';
import counterReducer from './counter';


import {combineReducers} from 'redux';
import weather from './weather_data';
const allReducers = combineReducers({
    
    counter: counterReducer,
    city_name: cn,
    weather: weather,
})

export default allReducers;
